/**
 * Descarta resposta de request antigo. Sem isso, ao parar de remontar a
 * lista por tecla, "cob" (lento) pode responder depois de "cobrança" (rápido)
 * e sobrescrever a lista com resultado stale.
 */
export function createRequestSequence() {
  let current = 0;
  return {
    next() {
      current += 1;
      return current;
    },
    isCurrent(id) {
      return id === current;
    },
  };
}
